<style lang="sass">
.reservations-table-reservations-shift-box {
  position: absolute;
  box-shadow: 2px 2px 2px -1px #aaa;

  .reservation-box-body {
    border: solid 1px lightgray;
    background-color: white;
    width: 100%;
    height: 90%;
    padding: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    .reservation-status:hover {
      cursor: default;
    }
  }

  .reservation-box-footer {
    width: 100%;
    height: 10%;

    .operation {
      float: left;
      height: 100%;
    }
    .operation-dyeing {
      @extend .operation;
      background-color: paleturquoise;
    }
    .operation-waiting {
      @extend .operation;
      background-color: palegoldenrod;
    }
    .operation-shampoo {
      @extend .operation;
      background-color: palevioletred;
    }
    .operation-dummy-dyeing {
      @extend .operation;
      background-color: gray;
    }
    .operation-dummy-waiting {
      @extend .operation;
      background-color: gray;
    }
    .operation-dummy-shampoo {
      @extend .operation;
      background-color: gray;
    }
  }

  .label.happy-turn {
    background-color: #EB984E;
  }

  .label.royal-turn {
    background-color: #76D7C4;
  }

  .other-operation {
    position: absolute;
    background-color: gray;
    height: 100%;
    opacity: 0.6;
  }
}
</style>


<template>
<div class="reservations-table-reservations-shift-box" :style="boxStyle">
  <div class="other-operation" :style="otherOperationStyle"></div>
  <div class="reservation-box-body"
       :style="bodyStyle"
       @click="$dispatch('click-reservation', reservation, $event)"
       title="{{{ tooltipContent }}}">
    <div>
      <span
          v-if="!reservation.isRemoved"
          class="label label-default reservation-status"
          v-bind:class="displayStatusClass"
          :disabled="isLoading"
          @click.stop="toggleVisited()"
      >{{{ displayStatus }}}</span>
      <span v-if="reservation.parseWarning" class="label label-danger">
        <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
      </span>
      <span
          v-if="reservation.isRemoved"
          class="label label-default reservation-status"
      >削除済み</span>
      <span
          v-if="customer.isNew"
          class="label label-default reservation-status"
      >新規</span>
      <!-- 予約メモがある場合のアイコン -->
      <span v-if="reservation.note" class="label label-info">
        <span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span>
      </span>
      <!-- 顧客メモがある場合のアイコン -->
      <span v-if="customer.note" class="label label-warning">
        <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
      </span>
      <!-- ホットペッパービューティーからの予約の場合のアイコン -->
      <span v-if="isReservedByHotpepper" class="label label-danger">
        <span class="glyphicon glyphicon-bold" aria-hidden="true"></span>
      </span>
      <!-- 顧客紐付け済み -->
      <span v-if="isLinkedCrm" :class="['label', isAssignedUser ? 'label-warning' : 'label-default']">
        <span class="glyphicon glyphicon-user" aria-hidden="true"></span>
      </span>
      <span v-if="isHappyTurn" class="label label-default happy-turn">
        <span>HT</span>
      </span>
      <span v-if="isRoyalTurn" class="label label-default royal-turn">
        <span>RT</span>
      </span>
    </div>
    {{{ reservationContent }}}
  </div>
  <div class="reservation-box-footer">
    <div class="operation-dyeing" :style="operationStyle(reservation._embedded.menu.timeboxes.dyeing)"></div>
    <div class="operation-waiting" :style="operationStyle(reservation._embedded.menu.timeboxes.waiting)"></div>
    <div class="operation-shampoo" :style="operationStyle(reservation._embedded.menu.timeboxes.shampoo)"></div>
  </div>
</div>
</template>


<script>
import moment from 'moment'
import $ from 'jquery'
import ReservationStatus from 'ReservationStatus'
import ReservedBy from 'ReservedBy'

export default {
  name: 'reservations-table-reservations-shift-box',
  props: {
    shop: {
      type: Object,
      required: true,
    },
    businessHour: {
      type: Object,
      required: true,
    },
    pxPerMinute: {
      type: Number,
      required: true,
    },
    reservation: {
      type: Object,
      required: true,
    },
    track: {
      type: Number,
      required: true,
    },
    staff: {
      type: Object,
      required: false,
    },
    height: {
      type: Number,
      required: true,
    },
    marginTop: {
      type: Number,
      required: true,
    },
    marginBottom: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      isLoading: false,
    }
  },
  computed: {
    isHappyTurn () {
      return this.customer.isHappyTurn
    },
    isRoyalTurn () {
      return this.customer.isRoyalTurn
    },
    top() {
      return this.track * (this.marginTop + this.height + this.marginBottom) + this.marginTop
    },
    left() {
      let range = moment.range(`${this.businessHour.openAt}/${this.reservation.startAt}`)
      return this.pxPerMinute * range.diff('minutes')
    },
    width() {
      let range = moment.range(`${this.reservation.startAt}/${this.reservation.endAt}`)
      return range.diff('minutes') * this.pxPerMinute
    },
    boxStyle() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        top: this.top + 'px',
        left: this.left + 'px',
      }
    },
    otherOperationStyle() {
      const none = {display: 'none;'}
      const staffPk = this.staff ? this.staff.pk : null

      const first = (this.reservation._embedded.menu.timeboxes.dyeing + this.reservation._embedded.menu.timeboxes.waiting) * this.pxPerMinute
      const second = this.reservation._embedded.menu.timeboxes.shampoo * this.pxPerMinute

      if (this.reservation.respondingShampooStaff) {
        if (this.reservation.respondingStaff === this.reservation.respondingShampooStaff) {
          return none
        } else if (this.reservation.respondingStaff !== staffPk && this.reservation.respondingShampooStaff !== staffPk) {
          return none
        } else if (this.reservation.respondingStaff === staffPk) {
          // シャンプーの施術だけ他人が行う
          return {
            left: first + 'px',
            width: second + 'px',
          }
        } else {
          // 塗布の施術だけ他人が行う
          return {
            width: first + 'px',
          }
        }

      }
    },
    bodyStyle() {
      if (this.reservation.status == ReservationStatus.VISITED
          || this.reservation.status == ReservationStatus.CANCELLED
          || this.reservation.status == ReservationStatus.NO_SHOW
          || this.reservation.isRemoved) {
        return {
          'background-color': '#ddd',
        }
      } else {
        return {}
      }
    },
    customer() {
      return this.reservation.customer
    },
    displayStatus() {
      if (this.isLoading) {
        return '処理中...'
      }
      switch (this.reservation.status) {
        case ReservationStatus.NEW:
          return '来店待ち'
        case ReservationStatus.VISITED:
          return '来店済み'
        case ReservationStatus.CANCELLED:
          return 'キャンセル'
        case ReservationStatus.NO_SHOW:
          return '来店なし'
      }
    },
    displayStatusClass() {
      switch (this.reservation.status) {
        case ReservationStatus.NEW:
          return 'label-primary'
        case ReservationStatus.VISITED:
          return 'label-success'
        case ReservationStatus.CANCELLED:
          return 'label-default'
        case ReservationStatus.NO_SHOW:
          return 'label-default'
      }
    },
    optionIcon() {
      // メニューオプションがある場合のアイコン
      if (this.reservation.menuOptions.length > 0) {
        return '<span class="glyphicon glyphicon-option-horizontal" aria-hidden="true"></span>'
      } else {
        return ''
      }
    },
    dyeInfo() {
      let operationHistory = null

      if (this.reservation.operationHistory &&
          (this.reservation.operationHistory.usedDyestuffsForRoots.length > 0
        || this.reservation.operationHistory.usedDyestuffsForEnds.length > 0)
      ) {
        operationHistory = this.reservation.operationHistory
      } else if (this.reservation.lastOperationHistory &&
                 (this.reservation.lastOperationHistory.usedDyestuffsForRoots.length > 0
               || this.reservation.lastOperationHistory.usedDyestuffsForEnds.length > 0)
      ) {
        operationHistory = this.reservation.lastOperationHistory
      } else {
        return ''
      }

      let root = operationHistory.usedDyestuffsForRoots.map(
        usedDyestuff => `${usedDyestuff._embedded.dyestuff.name}(${usedDyestuff.amount}g)`
      )
      let end = operationHistory.usedDyestuffsForEnds.map(
        usedDyestuff => `${usedDyestuff._embedded.dyestuff.name}(${usedDyestuff.amount}g)`
      )

      let usedSolutionForRoots = ''
      let usedSolutionForEnds = ''
      if (operationHistory.usedSolutionForRoots) {
        usedSolutionForRoots = ':' + operationHistory.usedSolutionForRoots + '%'
      }
      if (operationHistory.usedSolutionForEnds) {
        usedSolutionForEnds = ':' + operationHistory.usedSolutionForEnds + '%'
      }

      return `根元:${root.join(',')}${usedSolutionForRoots}<br>毛先:${end.join(',')}${usedSolutionForEnds}`
    },
    reservationContent() {
      let familyNameKana = this.customer.familyNameKana ? this.customer.familyNameKana : ''
      let firstNameKana = this.customer.firstNameKana ? this.customer.firstNameKana : ''
      let content = `${moment(this.reservation.startAt).format('k:mm')}〜`
                  + ` ${familyNameKana} ${firstNameKana} 様`
                  + `<br>${this.reservation._embedded.menu.name} ${this.optionIcon}`
      if (this.dyeInfo) {
        content += `<br>${this.dyeInfo}`
      }
      return content
    },
    tooltipContent() {
      let content = this.reservationContent
      if (this.customer.visitCount) {
        content += `<br>来店回数: ${this.customer.visitCount}回`
        content += `<br>1年間の来店回数: ${this.customer.yearVisitCount}回`
        content += `<br>前回の来店日時: ${moment(this.customer.prevVisitDate).format('YYYY年MM月DD日')} (${this.customer.fromPrevVisit}日前に来店)`
      }
      return content.replace(/<br>/ig, "\n").replace(/(<([^>]+)>)/ig, "")
    },
    isReservedByHotpepper() {
      return this.reservation.reservedBy == ReservedBy.HOTPEPPER
    },
    isLinkedCrm () {
      return !!(this.reservation.customer.crmUuid)
    },
    isAssignedUser() {
      return Boolean(this.reservation.customer.customerUserEmail)
    },
  },
  methods: {
    toggleVisited() {
      if (this.isLoading) {
        return
      }
      if (this.reservation.status != ReservationStatus.NEW
          && this.reservation.status != ReservationStatus.VISITED) {
        return
      }

      let newStatus =
        this.reservation.status == ReservationStatus.NEW ? ReservationStatus.VISITED : ReservationStatus.NEW

      this.isLoading = true
      return this.apiPut(
        `/api/1.0/reservations/${this.reservation.pk}/`,
        {status: newStatus},
        {shopAs: this.shop.pk}
      ).then(response => {
        this.reservation = Object.assign({}, response.body.data)  // reservation更新検知のため差し替え
      }).finally(() => {
        this.isLoading = false
      })
    },
    changeReservationStatus() {
      if (this.reservation['visited']) {
        this.reservation['visited'] = false
        this.reservation['waiting'] = true
      } else if (this.reservation['waiting']
                 || !this.reservation['passed']
                 && !this.reservation['deleted']
                 && !this.reservation['cancelled']
      ) {
        this.reservation['visited'] = true
        this.reservation['waiting'] = false
      }
      this.updateStatus()
    },
    operationStyle(minutes) {
      return {
        width: `${minutes * this.pxPerMinute}px`
      }
    },
  },
  mixins: [
    require('mixin/api-client.vue'),
    require('mixin/wait.vue'),
  ],
}
</script>



// WEBPACK FOOTER //
// box.vue?95c7cfe0